document.addEventListener("click", function(e){
  const trigger = e.target.closest(".share-trigger");
  const pop = document.getElementById("share-popover");
  if(trigger){
    e.preventDefault();
    e.stopPropagation();
    const url = window.location.href;
    const text = document.title;
    pop.querySelector('[data-share="whatsapp"]').href = "https://wa.me/?text=" + encodeURIComponent(text + " " + url);
    pop.querySelector('[data-share="facebook"]').href = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url);
    pop.querySelector('[data-share="twitter"]').href = "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url) + "&text=" + encodeURIComponent(text);
    pop.querySelector('[data-share="email"]').href = "mailto:?subject=" + encodeURIComponent(text) + "&body=" + encodeURIComponent(url);
    pop.hidden = false;
    const rect = trigger.getBoundingClientRect();
    const inner = pop.querySelector(".share-popover__inner");
    inner.style.position = "relative";
    const popRect = inner.getBoundingClientRect();
    let top = rect.top - popRect.height - 10;
    let left = rect.left - popRect.width - 18; // further left
    if(top < 10) top = rect.bottom + 10;
    if(left < 10) left = 10;
    if(left + popRect.width > window.innerWidth - 10) left = window.innerWidth - popRect.width - 10;
    pop.style.top = `${top}px`;
    pop.style.left = `${left}px`;
    return;
    return;
  }
  if(e.target.closest(".share-popover__copy")){
    navigator.clipboard.writeText(window.location.href);
    const btn=e.target.closest(".share-popover__copy");
    btn.textContent="Copied!";
    setTimeout(()=>btn.textContent="Copy link",1200);
    return;
  }
  if(!e.target.closest("#share-popover")){
    if(pop) pop.hidden=true;
  }
});
document.addEventListener("keydown", function(e){
  if(e.key==="Escape"){
    const pop=document.getElementById("share-popover");
    if(pop) pop.hidden=true;
  }
});